<template>
  <div class="container-fluid">
    <div class="row">
      <div
        class="modal fade"
        id="genericErrorModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        v-on:click="closeGenericErrorModal"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              v-on:click="closeGenericErrorModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>

            <div class="modal-body">
              <p v-if="genericErrorModalMessage === null">
                Sorry that didn’t work, please try again.
              </p>
              <p v-else>
                {{ genericErrorModalMessage }}
              </p>
              <a
                ><button
                  data-dismiss="modal"
                  class="white"
                  v-on:click="closeGenericErrorModal"
                >
                  Ok
                </button></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    isGenericErrorModaleActive: {
      get() {
        return this.$store.state.settings.isGenericErrorModaleActive;
      },
      set(value) {
        this.$store.commit("updateIsGenericErrorModaleActiveMutation", value);
      }
    },

    genericErrorModalMessage: {
      get() {
        return this.$store.state.settings.genericErrorModalMessage;
      },
      set(value) {
        this.$store.commit("updateGenericErrorModalMessageMutation", value);
      }
    }
  },
  methods: {
    closeGenericErrorModal: function() {
      this.isGenericErrorModaleActive = false;
      this.genericErrorModalMessage = null;
    }
  },
  watch: {
    isGenericErrorModaleActive: function() {
      if (this.isGenericErrorModaleActive) {
        window.$("#genericErrorModal").modal("show");
      }
    }
  }
};
</script>
